var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    class: ['grid', ("grid_" + (_vm.count) + "-count")]
  }, [_vm._l(_vm.list, function (category, index) {
    var _category$image;

    return _c('div', {
      key: index,
      staticClass: "grid__item"
    }, [_c('GGLink', {
      staticClass: "category",
      attrs: {
        "to": category.path
      },
      nativeOn: {
        "click": function ($event) {
          return _vm.$emit('category-click', category);
        }
      }
    }, [_c('div', {
      staticClass: "category__text-wrap"
    }, [_c('div', {
      staticClass: "category__title",
      attrs: {
        "to": category.path
      }
    }, [_vm._v("\n          " + _vm._s(category.name) + "\n        ")]), _vm._v(" "), category.minimalProductPrice ? _c('span', {
      staticClass: "category__desc"
    }, [_vm._v("\n          от " + _vm._s(_vm.formatPrice(category.minimalProductPrice)) + "₽\n        ")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "category__img-wrap"
    }, [_c('div', {
      staticClass: "category__img-link"
    }, [category !== null && category !== void 0 && (_category$image = category.image) !== null && _category$image !== void 0 && _category$image.original ? _c('img', {
      staticClass: "category__img",
      attrs: {
        "crossorigin": "anonymous",
        "src": category.image.original,
        "alt": category.name
      }
    }) : _vm._e()])])])], 1);
  }), _vm._v(" "), _c('GGLink', {
    staticClass: "category-link",
    attrs: {
      "to": _vm.link
    }
  }, [_c('div', {
    staticClass: "category-link-wrap"
  }, [_c('span', {
    staticClass: "category-link__title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('button', {
    staticClass: "category-link__btn"
  })])])], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }